import * as a from '../../../actions'

import * as Form from './Form'
import * as Photo from './photo'
import * as Checkin from './checkin'
import * as Recognition from './recognition'

// TODO: update answerUpdate with attempt and step
const answer_reducers = {
  form: Form,
  photo: Photo,
  file: File,
  checkin: Checkin,
  recognition: Recognition,
}

const initalStateAnswer = page =>
  answer_reducers[page.page_type].initialState(page)

const newAnswer = (answer, payload, attempt, step) =>
  answer_reducers[answer.page_type].answerUpdate(answer, payload, attempt, step)

export const initialState = ({ id, state, mission_pages = [] } = { mission_pages: [] }) => ({
  attempt: 0,
  id,
  state,
  mission_id: id,
  mission: {
    id,
  },
  mission_pages: mission_pages.filter(page =>
    answer_reducers[page.page_type],
  ).map(page => ({
    ...initalStateAnswer(page),
    page_type: page.page_type,
    id: page.id,
  })),
})

export const answersUpdate = (state = initialState(), { type, payload }) => {
  switch (type) {
    case a.MISSION_ANSWER_INIT:
      return initialState(payload)
    case a.PROCESS_MISSION_ANSWER_DONE:
      return {
        ...state,
        mission_pages: state.mission_pages.slice(0).map(
          answer => newAnswer(answer, payload),
        ),
      }
    case a.PARTIAL_MISSION_ANSWER_DONE:
      const {
        answers,
        attempt,
        step,
      } = payload
      return {
        ...state,
        mission_pages: state.mission_pages.slice(0).map(
          answer => newAnswer(answer, payload, attempt, step),
        ),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/index.jsx